import { clearDisable } from "../../lib/flatpickr-utils";

// copy-pasted from flatpickr code
const getEventTarget = (event) => {
  try {
    if (typeof event.composedPath === "function") {
      const path = event.composedPath();
      return path[0];
    }
    return event.target;
  } catch (error) {
    return event.target;
  }
};

const DEFAULT_CONFIG = {
  maxWeeks: undefined,
};

const ONE_DAY_IN_MILISECONDS = 86400000;
const ONE_WEEK_IN_MILISECONDS = ONE_DAY_IN_MILISECONDS * 7;

const weeklyRange = (config = DEFAULT_CONFIG) => {
  return (fp) => {
    if (fp.config.mode !== "range") return;

    const daysByMonth = () =>
      Array.from(fp.daysContainer.childNodes).map((dayContainer) =>
        Array.from(dayContainer.childNodes),
      );
    const days = () => daysByMonth().flat();
    const dayIndex = (day) => day.$i;
    const monthIndex = (day) =>
      Array.from(fp.daysContainer.children).indexOf(day.parentElement);
    const dayIndSeven = (day) => dayIndex(day) / 7;

    const getWeekStartDate = (day) =>
      daysByMonth()[monthIndex(day)][7 * Math.floor(dayIndSeven(day))].dateObj;
    const getWeekEndDate = (day) =>
      daysByMonth()[monthIndex(day)][7 * Math.ceil(dayIndSeven(day) + 0.01) - 1]
        .dateObj;

    const onDayHover = (event) => {
      if (fp.selectedDates.length >= 2) return;

      const hoveredDay = getEventTarget(event);
      if (hoveredDay.classList.contains("flatpickr-disabled")) return;
      if (!hoveredDay.classList.contains("flatpickr-day")) return;

      const weekStartDate = getWeekStartDate(hoveredDay);
      const weekEndDate = getWeekEndDate(hoveredDay);

      days().forEach((day) => {
        const date = day.dateObj;
        if (date > weekEndDate || date < weekStartDate) {
          if (fp.selectedDates.length === 0) {
            day.classList.remove("inRange");
          }
        } else {
          day.classList.add("inRange");
        }

        if (date.getTime() === weekEndDate.getTime()) {
          day.classList.add("endRange");
        } else {
          day.classList.remove("endRange");
        }

        if (
          fp.selectedDates.length === 0 &&
          date.getTime() === weekStartDate.getTime()
        )
          day.classList.add("startRange");
        else if (
          fp.selectedDates.length === 1 &&
          fp.selectedDates[0].getTime() == day.dateObj.getTime()
        )
          day.classList.add("startRange");
        else day.classList.remove("startRange");
      });
    };

    const onValueUpdate = (event) => {
      if (![1, 2].includes(fp.selectedDates.length)) return;

      const day = fp.selectedDateElem;
      if (day === undefined) return;
      if (monthIndex(day) === -1) return;

      const dateToSelect =
        fp.selectedDates.length === 1
          ? getWeekStartDate(day)
          : getWeekEndDate(day);

      const dayToSelect = days().find(
        (day) => day.dateObj.getTime() === dateToSelect.getTime(),
      );

      if (fp.selectedDates.length === 1) {
        fp.selectedDates = [dateToSelect];

        dayToSelect.classList.add("selected", "inRange", "startRange");

        fp.config.disable.push((date) => date < dateToSelect);

        if (config.maxWeeks !== undefined) {
          const maxDate =
            dateToSelect.getTime() +
            config.maxWeeks * ONE_WEEK_IN_MILISECONDS -
            ONE_DAY_IN_MILISECONDS;

          fp.config.disable.push((date) => date > maxDate);
        }
      } else if (fp.selectedDates.length === 2) {
        fp.selectedDates = [fp.selectedDates[0], dateToSelect];

        fp.config.disable.pop();
        if (config.maxWeeks !== undefined) {
          fp.config.disable.pop();
        }
      }

      fp.selectedDateElem.classList.remove("selected");

      fp.selectedDateElem = dayToSelect;
      fp.latestSelectedDateObj = dateToSelect;

      fp.updateValue(false);
      fp.redraw();
    };

    const onReady = () => {
      if (fp.daysContainer !== undefined)
        fp.daysContainer.addEventListener("mouseover", onDayHover);
    };

    const onDestroy = () => {
      if (fp.daysContainer !== undefined)
        fp.daysContainer.removeEventListener("mouseover", onDayHover);
    };

    return {
      onValueUpdate,
      onClose: () => {
        clearDisable(fp, config.maxWeeks);
      },
      onOpen: onValueUpdate,
      onReady: [
        onReady,
        onValueUpdate,
        () => {
          fp.loadedPlugins.push("weeklyRange");
        },
      ],
      onDestroy,
    };
  };
};

export default weeklyRange;
